export default __webpack_public_path__ + "static/media/indications-template.1f59b8f9.svg";